import { apiClient } from "@/shared/api/client"
import type { CustomBot } from "./types"

export const setPaymentToken = async (id: string, token: string) =>
	(await apiClient.put<CustomBot>(`/admin/custom-bots/${id}/payment-token`, { token })).data

export const removePaymentToken = async (id: string) =>
	(await apiClient.delete<CustomBot>(`/admin/custom-bots/${id}/payment-token`)).data

export interface BotPayment {
	id: string
	title: string
	/** В копейках. */
	amount: number
	currency: string
	status: "PENDING" | "PAID"
	testMode: boolean
	telegramUserId: string
	telegramChargeId: string | null
	providerChargeId: string | null
	orderInfo: { name?: string; phone?: string; email?: string } | null
	createdAt: string
	paidAt: string | null
	customer: { firstName?: string; lastName?: string | null; username?: string | null } | null
}

export interface BotPaymentsPage {
	items: BotPayment[]
	totals: { live: { count: number; amount: number }; test: { count: number; amount: number } }
}

export const listBotPayments = async (id: string, status?: "PENDING" | "PAID") =>
	(
		await apiClient.get<BotPaymentsPage>(`/admin/custom-bots/${id}/payments`, {
			params: status ? { status } : {},
		})
	).data
